function getTrimmedString(value) {
	return typeof value === "string" ? value.trim() : "";
}

function parseObject(value) {
	if (value && typeof value === "object" && !Array.isArray(value)) {
		return value;
	}
	if (typeof value !== "string" || value.trim() === "") {
		return null;
	}

	try {
		const parsed = JSON.parse(value);
		return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null;
	} catch (err) {
		return null;
	}
}

export function getIdentityDisplayName(identity = {}) {
	if (!identity || typeof identity !== "object") {
		return "";
	}

	return getTrimmedString(identity.displayName)
		|| getTrimmedString(identity.name)
		|| getTrimmedString(identity.label);
}

export function isTrue(value) {
	return value === true
		|| value === 1
		|| getTrimmedString(value).toLowerCase() === "true";
}

export function getPerformerDisplayName(performer = {}) {
	const parsedPerformer = parseObject(performer);
	if (!parsedPerformer) {
		return "";
	}

	return getIdentityDisplayName(parsedPerformer)
		|| getTrimmedString(parsedPerformer.operatorId)
		|| getTrimmedString(parsedPerformer.ambifiIdentityId)
		|| getTrimmedString(parsedPerformer.identityId);
}

function getCompletedByDisplayPolicy(authorProperties) {
	const canonicalConfig = parseObject(authorProperties && authorProperties.sharedDeviceOperator);
	if (canonicalConfig && Number(canonicalConfig.schemaVersion) === 1) {
		return {
			displayCompletedBy: canonicalConfig.enabled === true
				&& canonicalConfig.displayCompletedBy !== false,
			allItemTypes: true
		};
	}

	const legacyConfig = parseObject(authorProperties && authorProperties.sharedTaskIdentity);
	return {
		displayCompletedBy: !!legacyConfig && legacyConfig.displayCompletedBy === true,
		allItemTypes: false
	};
}

export function getCompletedByDisplayName(activity = {}, item = {}, options = {}) {
	const authorProperties = parseObject(activity && activity.authorProperties);
	const policy = getCompletedByDisplayPolicy(authorProperties);
	const itemType = getTrimmedString(item && item.type);
	const isSupportedItemType = policy.allItemTypes
		? itemType.toLowerCase().startsWith("item")
		: itemType === "item";
	if (
		!policy.displayCompletedBy
		|| !item
		|| !isSupportedItemType
		|| isTrue(item.labelOnly)
		|| !isTrue(item.checked)
	) {
		return "";
	}

	if (options.allowIdentifierFallback === false) {
		const completedBy = parseObject(item.completedBy);
		return completedBy ? getIdentityDisplayName(completedBy) : "";
	}

	return getPerformerDisplayName(item.completedBy);
}

export function getHistoryPerformerDisplayName(historyItem = {}, options = {}) {
	if (!historyItem || typeof historyItem !== "object") {
		return "";
	}

	const performedBy = parseObject(historyItem.performedBy);
	const performedByDisplayName = options.allowIdentifierFallback === false
		? (performedBy ? getIdentityDisplayName(performedBy) : "")
		: getPerformerDisplayName(historyItem.performedBy);
	if (performedByDisplayName) {
		return performedByDisplayName;
	}

	return historyItem.type === "item" && historyItem.action === "check"
		? getTrimmedString(historyItem.displayName)
		: "";
}
